/**
 * VTO Widget i18n — no third-party branding.
 * Resolve locale from account settings (auto = browser/location) or manual.
 */

import en from './en.json';
import bs from './bs.json';
import hr from './hr.json';
import de from './de.json';

const bundles = { en, bs, hr, de };
const supportedLocales = ['en', 'bs', 'hr', 'de', 'sr', 'fr', 'es', 'it', 'nl', 'pl', 'pt', 'ru', 'tr', 'ar', 'ja', 'zh'];

function loadBundle(locale) {
  return bundles[locale] || null;
}

function getEn() {
  return en;
}

/**
 * Resolve display locale from widget API config.
 * Manual = use account's chosen locale. Auto = use visitor's browser language.
 * @param {Object} widgetSettings - { languageMode: 'auto'|'manual', locale: string }
 * @returns {string} BCP 47 language tag (e.g. 'en', 'bs', 'de')
 */
export function resolveLocale(widgetSettings) {
  if (widgetSettings?.languageMode === 'manual' && widgetSettings?.locale) {
    const code = String(widgetSettings.locale).split('-')[0].toLowerCase();
    if (supportedLocales.includes(code)) return code;
    return code;
  }
  // Auto: use visitor's browser language (only if we have a bundle, else fallback to en)
  if (typeof navigator !== 'undefined') {
    const browserLang = (navigator.language || navigator.userLanguage || 'en').split('-')[0].toLowerCase();
    if (bundles[browserLang]) return browserLang;
    if (supportedLocales.includes(browserLang)) return browserLang;
  }
  return 'en';
}

/**
 * Get translation function for the given locale.
 * @param {string} locale - e.g. 'en', 'bs'
 * @returns {(key: string, params?: { seconds?: number }) => string}
 */
export function getTranslations(locale) {
  const code = String(locale || 'en').split('-')[0].toLowerCase();
  const bundle = loadBundle(code) || getEn();
  return function t(key, params) {
    let s = bundle[key];
    if (s == null) s = getEn()[key];
    if (s == null) return key;
    if (params?.seconds != null) s = s.replace('{seconds}', params.seconds);
    return s;
  };
}

export { supportedLocales };
